import mutations from './mutations';
import axios from 'axios';
import api, { setAccessToken, setProfile } from '../api';

function getUserMapping() {
  try {
    return JSON.parse(localStorage.user_mapping || '');
  } catch (e) {
    return [];
  }
}
function getSshcpMapping() {
  try {
    return JSON.parse(localStorage.sshcp_mapping || '');
  } catch (e) {
    return [];
  }
}

export default {
  namespaced: true,
  state: {
    loading: false,
    isLoggedIn: !!localStorage.getItem('profile_id'),
    access_token: null,
    userMenu: [],
    profile: null,
    userRole: null,
    mapping: getUserMapping(),
    sshcpMapping: getSshcpMapping()
  },
  mutations: {
    [mutations.SET_USER_MAPPING](state, mapping) {
      state.mapping = mapping;
    },
    [mutations.SET_SSHCP_MAPPING](state, sshcpMapping) {
      state.sshcpMapping = sshcpMapping;
    },
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    },
    [mutations.SET_LOGIN](state, token) {
      state.access_token = token;
    },
    [mutations.SET_MENU](state, data) {
      localStorage.setItem('menu', JSON.stringify(data.permission));
      localStorage.setItem('filters', JSON.stringify(data.listGroup));
      state.userMenu = data.permission;
      state.isLogout = false;
      state.isLoggedIn = true;
    },
    [mutations.SET_PROFILE](state, data) {
      state.params = data;
      const profile = localStorage.getItem('profile_id');
      setProfile(profile);
    },
    [mutations.SET_LOGOUT](state) {
      localStorage.removeItem('app_token');
      localStorage.removeItem('menu');
      localStorage.removeItem('profile');
      localStorage.removeItem('userProfile');
      localStorage.removeItem('profile_id');
      localStorage.removeItem('username');
      localStorage.removeItem('profileList');
      localStorage.removeItem('name');
      localStorage.removeItem('user');
      localStorage.removeItem('user_mapping');
      localStorage.removeItem('iv');
      state.isLogout = true;
      state.isLoggedIn = false;
    },
    [mutations.SET_USER_ROLE](state, role) {
      state.userRole = role;
    }
  },
  actions: {
    login({ commit }, data) {
      return new Promise((resolve, reject) => {
        api.auth
          .login(data, {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }
          })
          .then(res => {
            const username = res.data.data.email;
            const name = res.data.data.name;
            const token = res.data.data.token;
            const profileList = res.data.data.profiles;
            const mapping = res.data.data.mapping;
            const sshcpMapping = res.data.data.sshcpMapping;
            const user = res.data.data;
            setAccessToken(token);
            localStorage.setItem('app_token', token);
            localStorage.setItem('username', username);
            localStorage.setItem('name', name);
            localStorage.setItem('profileList', JSON.stringify(profileList));
            localStorage.setItem('user', JSON.stringify(user));
            localStorage.setItem('user_mapping', JSON.stringify(mapping));
            localStorage.setItem('sshcp_mapping', JSON.stringify(sshcpMapping));
            commit('SET_LOGIN', res);
            commit('SET_USER_MAPPING', mapping);
            commit('SET_SSHCP_MAPPING', sshcpMapping);
            resolve(res);
            return res;
          })
          .catch(err => {
            reject(err);
            return err;
          });
      });
    },
    loginOptima({ commit }, data) {
      return new Promise((resolve, reject) => {
        api.auth
          .loginOptima(data, {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }
          })
          .then(res => {
            const username = res.data.data.email;
            const name = res.data.data.name;
            const token = res.data.data.token;
            const profileList = res.data.data.profiles;
            const user = res.data.data;
            setAccessToken(token);
            localStorage.setItem('app_token', token);
            localStorage.setItem('username', username);
            localStorage.setItem('name', name);
            localStorage.setItem('profileList', JSON.stringify(profileList));
            localStorage.setItem('user', JSON.stringify(user));
            commit('SET_LOGIN', res);
            resolve(res);
            return res;
          })
          .catch(err => {
            reject(err);
            return err;
          });
      });
    },
    getRoleConfig({ commit }, params) {
      commit(mutations.LOADING);
      return api.auth
        .getRoleConfig(params)
        .then(({ data }) => {
          commit(mutations.SET_MENU, data.data);
          localStorage.setItem('profile', JSON.stringify(params));
          commit(mutations.SET_PROFILE, params);
          commit(mutations.LOADED);
          commit(mutations.SET_USER_ROLE, data.data);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    logout({ commit }) {
      localStorage.removeItem('app_token');
      localStorage.removeItem('profile_id');
      localStorage.removeItem('username');
      localStorage.removeItem('iv');
      axios.defaults.headers.common['profile_id'] = null;
      commit(mutations.SET_LOGOUT);
    },
    create({ commit }, payload) {
      commit(mutations.LOADING);
      return api.auth
        .create(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    listProfile({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.auth
        .listProfile(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(() => {
          commit(mutations.LOADED);
        });
    },
    getAll({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.auth
        .getAll(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(() => {
          commit(mutations.LOADED);
        });
    },
    detail({ commit }, id) {
      commit(mutations.LOADING);
      return api.auth
        .detail(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(() => {
          commit(mutations.LOADED);
        });
    },
    update({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.auth
        .update(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    changePassword({ commit }, params) {
      commit(mutations.LOADING);
      return api.auth
        .changePassword(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    resetPassword({ commit }, email) {
      commit(mutations.LOADING);
      return api.auth
        .resetPassword(email)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    createPassword({ commit }, { token, params }) {
      commit(mutations.LOADING);
      return api.auth
        .createPassword(token, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getCompability({ commit }) {
      commit(mutations.LOADING);
      return api.auth
        .getCompability()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(() => {
          commit(mutations.LOADED);
        });
    },
    getCompabilityCheck({ commit }) {
      commit(mutations.LOADING);
      return api.auth
        .getCompabilityCheck()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(() => {
          commit(mutations.LOADED);
        });
    },
    updateCompability({ commit }, days) {
      commit(mutations.LOADING);
      return api.auth
        .updateCompability(days)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    updateStatus({ commit }, { id, paramUser }) {
      commit(mutations.LOADING);
      return api.auth
        .updateStatus(id, paramUser)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    }
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    user: state => state.user,
    token: state => state.token,
    isLoading: state => state.loading,
    error: state => {
      if (state.error && state.error.response) {
        return state.error.response.data;
      }
      return state.error;
    },
    userMenu: state => state.userMenu,
    permissions: state => {
      return state.userMenu.map(item => {
        return {
          name: item.name,
          permission: item.permission
        };
        // return Object.keys(state.userMenu[item]).map(name => ({
        //   name,
        //   permissions: state.userMenu[item][name]
        // }));
      });
      // .flat();
    },
    userMapping: state => state.userRole && state.userRole.mapping,
    sshcpMapping: state => state.userRole && state.userRole.sshcpMapping,
    userPosition: state => (state.userRole && state.userRole.potition) || ''
  }
};
